import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Img from "gatsby-image"
import tw, { css } from "twin.macro"

import SlideSection from "../components/slideSection"
import NextPageButton from "../components/nextPageButton"
import { SlideProps } from "."
import IconSubsidies from "../icons/subsidies"

const LogoSlide: React.SFC<SlideProps> = ({ slideVisible, nextButtonClicked, isClient }) => {

  const data = useStaticQuery(query);

  const logoSources = [
    {
      ...data.imageBackground.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]

  return (
    <SlideSection fullHeight>
      <div css={[tw`flex flex-col h-full justify-center items-center`]}>
        <div css={[tw`flex visible md:hidden flex-col w-full justify-center items-center z-10`]}>
          <div css={[
            css`max-width: 50rem;`, tw`flex w-full mr-8 md:mr-0 md:w-2/3 justify-end md:-mt-32`,
            // transitions
            tw`transition duration-500 ease-out delay-100`,
            !slideVisible && tw`opacity-0 transform -translate-y-16`]}>
            <IconSubsidies css={[tw``]} />
          </div>
          <p css={[tw`font-display text-white tracking-widest text-center pt-16 uppercase`]}>
            Introducing the MITO
          </p>
          <p css={[tw`font-display font-bold text-6xl text-white text-center mt-2`, css`line-height: 3.5rem;`]}>
            Automotive Apprentice
          </p>
          <p css={[tw`font-display text-xl md:text-3xl tracking-wider text-white text-center pt-10`]}>
            Your smartest investment
          </p>
        </div>


        <div css={[tw`absolute top-0 h-full w-full flex justify-center z-0`]}>
          <div css={[tw`visible md:hidden flex h-full w-full bg-black`]}>
            <Img
              css={[tw`flex h-full w-full`]}
              fluid={logoSources}
              imgStyle={{ objectFit: 'contain' }}
            />
          </div>

          <div css={[tw`absolute bottom-0 mb-16`]}>
            <NextPageButton onClick={nextButtonClicked} label="" />
          </div>
        </div>
      </div>
    </SlideSection>
  )
}

export const query = graphql`
  query {
    imageBackground: file(relativePath: { eq: "image_background.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`

export default LogoSlide
